import { queryClient } from 'queryClient';
import useAppMutation from 'hooks/useAppMutation';
import useNotify from 'hooks/useNotify';
import API from 'services/API';
import { useTranslation } from 'react-i18next';
import { getErrorMessage } from 'utils/axiosExceptionUtils';
import { IntegrationEnum } from 'models/InternalIntegrationSetting';
import { getIntegrationAgencySettingsQueryKey } from 'hooks/useFetchIntegrationAgencySettings';

export enum ReadOnlyAccessAction {
  ENABLE = 'enable',
  DISABLE = 'disable',
}

const useReadOnlyAccessMutation = () => {
  const { notifyError } = useNotify();
  const { t } = useTranslation();

  return useAppMutation({
    mutationFn: async (payload: {
      enumId: IntegrationEnum;
      action: ReadOnlyAccessAction;
    }) => {
      const { enumId, action } = payload;

      const response = await API.post(
        `/api/internal/integrations/default/${enumId}/read-only-access/${action}`,
      );

      return response.data;
    },
    onSettled: (_, __, { enumId }) => {
      queryClient.invalidateQueries({
        queryKey: getIntegrationAgencySettingsQueryKey({ enumId }),
      });
    },
    onError: (error: any) => {
      notifyError(
        getErrorMessage({
          apiErrorCode: error.response?.data?.apiErrorCode,
          apiErrorMessage: error.response?.data?.apiErrorMessage,
          baseKey: 'pageIntegrations.apiErrorCodes.',
          t,
        }),
      );
    },
  });
};

export default useReadOnlyAccessMutation;
